import {
  IFavouriteFilterGroupModel,
  IFavouriteFilterModel,
  IFavouriteFilterRequestModel,
  FavouriteFilterModel,
  FavouriteFilterRequestModel
} from "./../../models/favourite-filter/favourite-filter-model";
import { IBaseState } from "../index";
import {
  FavouriteFilterServices,
  IFavouriteFilterServices
} from "../../services/favourites-filter.services";

/**
 * STATE: INTERFACE
 */
export interface IFavouriteFilterState
  extends IBaseState<IFavouriteFilterServices, {}> {
  favouriteFilters?: IFavouriteFilterGroupModel[];
  currentFavourite?: IFavouriteFilterModel;
  currentRequestModel?: IFavouriteFilterRequestModel;
  service?: IFavouriteFilterServices;

  // Property
  propertyfavouriteFilters?: IFavouriteFilterGroupModel[];
  currentPropertyFavourite?: IFavouriteFilterModel;
  originalPropertyFavourite?: IFavouriteFilterModel;

  //Person
  personfavouriteFilters?: IFavouriteFilterGroupModel[];
  currentPersonFavourite?: IFavouriteFilterModel;
  originalPersonFavourite?: IFavouriteFilterModel;

  //Demand
  demandfavouriteFilters?: IFavouriteFilterGroupModel[];
  currentDemandFavourite?: IFavouriteFilterModel;
  originalDemandFavourite?: IFavouriteFilterModel;

  //Task
  taskfavouriteFilters?: IFavouriteFilterGroupModel[];
  currentTaskFavourite?: IFavouriteFilterModel;
  originalTaskFavourite?: IFavouriteFilterModel;
}

/**
 * STATE: IMPLEMENTED
 */
export class FavouriteFilterState implements IFavouriteFilterState {
  favouriteFilters: IFavouriteFilterGroupModel[];
  currentFavourite: IFavouriteFilterModel;
  currentRequestModel?: IFavouriteFilterRequestModel;
  service?: IFavouriteFilterServices;

  // Property
  propertyfavouriteFilters?: IFavouriteFilterGroupModel[];
  currentPropertyFavourite?: IFavouriteFilterModel;
  originalPropertyFavourite?: IFavouriteFilterModel;

  //Person
  personfavouriteFilters?: IFavouriteFilterGroupModel[];
  currentPersonFavourite?: IFavouriteFilterModel;
  originalPersonFavourite?: IFavouriteFilterModel;

  //Demand
  demandfavouriteFilters?: IFavouriteFilterGroupModel[];
  currentDemandFavourite?: IFavouriteFilterModel;
  originalDemandFavourite?: IFavouriteFilterModel;

  //Task
  taskfavouriteFilters?: IFavouriteFilterGroupModel[];
  currentTaskFavourite?: IFavouriteFilterModel;
  originalTaskFavourite?: IFavouriteFilterModel;

  constructor(options?: IFavouriteFilterState) {
    this.favouriteFilters = options.favouriteFilters || [];
    this.currentFavourite =
      options.currentFavourite || new FavouriteFilterModel();
    this.currentRequestModel =
      options.currentRequestModel || new FavouriteFilterRequestModel();
    this.service = options.service || new FavouriteFilterServices();

    // Property
    this.propertyfavouriteFilters = options.propertyfavouriteFilters || [];
    this.currentPropertyFavourite = options.currentPropertyFavourite || new FavouriteFilterModel();
    this.originalPropertyFavourite = options.originalPropertyFavourite || new FavouriteFilterModel();

    //Person
    this.personfavouriteFilters = options.personfavouriteFilters || [];
    this.currentPersonFavourite = options.currentPersonFavourite || new FavouriteFilterModel();
    this.originalPersonFavourite = options.originalPersonFavourite || new FavouriteFilterModel();

    //Demand
    this.demandfavouriteFilters = options.demandfavouriteFilters || [];
    this.currentDemandFavourite = options.currentDemandFavourite || new FavouriteFilterModel();
    this.originalDemandFavourite = options.originalDemandFavourite || new FavouriteFilterModel();

    //Task
    this.taskfavouriteFilters = options.taskfavouriteFilters || [];
    this.currentTaskFavourite = options.currentTaskFavourite || new FavouriteFilterModel();
    this.originalTaskFavourite = options.originalTaskFavourite || new FavouriteFilterModel();
  }
}
